import React, { useState } from "react";
import './CheckoutTile.css'
import { useCore } from "../hooks";
import { Btn, FormInput } from "./";
import { formatPrice } from "../utils";

export const CashCalculator: React.FC = () => {
  const { currentOrder, currency } = useCore()
  const [receivedAmount, setReceivedAmount] = useState<number>(0)

  const couponsSum = currentOrder?.paymentItems
    ?.filter(pi => pi?.payment?.type?.id === 'coupon')
    ?.reduce((sum, pi) => sum + Number(pi?.amount || 0), 0) || 0
  const cashPaymentRequestedAmount = Math.max(0, (currentOrder?.priceAll || 0) - couponsSum)

  return (
    <div className="bg-white">
      <h3 className="text-lg font-bold mt-4 mb-2">Výčetka - Kolik vrátit zákazníkovi</h3>
      <div className="flex flex-row gap-2 mb-4">
        <FormInput className="flex-grow mb-0!" inputclassName="w-full text-right font-bold text-xl h-full!" type={'number'} value={`${receivedAmount}`} onChange={val => setReceivedAmount(Number(val))} />
        <Btn className={'btn btn-error'} children={'Vynulovat'} onClick={() => setReceivedAmount(0)} />
      </div>
      <div className="flex flex-row gap-2">
        <div className="w-1/2 grid grid-cols-2 gap-2">
          <Btn className={'btn btn-base-100'} children={`1 ${currency.symbol}`} onClick={() => setReceivedAmount(receivedAmount + 1)} />
          <Btn className={'btn btn-base-100'} children={`2 ${currency.symbol}`} onClick={() => setReceivedAmount(receivedAmount + 2)} />
          <Btn className={'btn btn-base-100'} children={`5 ${currency.symbol}`} onClick={() => setReceivedAmount(receivedAmount + 5)} />
          <Btn className={'btn btn-base-100'} children={`10 ${currency.symbol}`} onClick={() => setReceivedAmount(receivedAmount + 10)} />
          <Btn className={'btn btn-base-100'} children={`20 ${currency.symbol}`} onClick={() => setReceivedAmount(receivedAmount + 20)} />
          <Btn className={'btn btn-base-100'} children={`50 ${currency.symbol}`} onClick={() => setReceivedAmount(receivedAmount + 50)} />
        </div>
        <div className="w-1/2 grid grid-cols-2 gap-2">
          <Btn className={'btn btn-primary btn-soft'} children={`100 ${currency.symbol}`} onClick={() => setReceivedAmount(receivedAmount + 100)} />
          <Btn className={'btn btn-primary btn-soft'} children={`200 ${currency.symbol}`} onClick={() => setReceivedAmount(receivedAmount + 200)} />
          <Btn className={'btn btn-primary btn-soft'} children={`500 ${currency.symbol}`} onClick={() => setReceivedAmount(receivedAmount + 500)} />
          <Btn className={'btn btn-primary btn-soft'} children={`1000 ${currency.symbol}`} onClick={() => setReceivedAmount(receivedAmount + 1000)} />
          <Btn className={'btn btn-primary btn-soft'} children={`2000 ${currency.symbol}`} onClick={() => setReceivedAmount(receivedAmount + 2000)} />
          <Btn className={'btn btn-primary btn-soft'} children={`5000 ${currency.symbol}`} onClick={() => setReceivedAmount(receivedAmount + 5000)} />
        </div>
      </div>
      <div className="flex justify-between font-bold mt-6">
        <span className="font-bold">Částka k vrácení:</span>
        <span className="text-error text-xl">{formatPrice(receivedAmount > 0 ? receivedAmount - cashPaymentRequestedAmount : 0, currency?.id)}</span>
      </div>
    </div>
  )
}
